import { render, staticRenderFns } from "./JeeVideoResourceUpload.vue?vue&type=template&id=27ef73ed&"
import script from "./JeeVideoResourceUpload.vue?vue&type=script&lang=js&"
export * from "./JeeVideoResourceUpload.vue?vue&type=script&lang=js&"
import style0 from "./JeeVideoResourceUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports